export default __webpack_public_path__ + "static/media/log_sample.d22c3f0e.jpg";